import { render } from "./company-form.vue?vue&type=template&id=2b070188"
import script from "./company-form.vue?vue&type=script&lang=js"
export * from "./company-form.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Cater-Frontend\\cater\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__